import React, { useState, useEffect } from 'react';
// 商品アイテム用コンポーネント
import ItemList from './ItemList'
// カレンダー用コンポーネント
import SSCalendar from './SSCalendar'
// 日付と時刻をパース・検証・操作・表示する最小のモダンブラウザ向けライブラリ
import dayjs from 'dayjs';


// 月の初期値（今月）
// 0：前月　1：今月　2：来月
const current = 1;

const App = (props) => {
	const { dev, conf } = props;

	// フック用の変数を準備
	const [items, setItems] = useState([]);
	// 0：前月　1：今月　2：来月
	const [monthcnt, setMonthCnt] = useState(current);

	if (dev) console.log("★App起動");
	if (dev) console.log("環境変数 PUBLIC_URL:" + process.env.PUBLIC_URL);

	/* ========================================================
	JSONファイルの読み込み
	=========================================================*/
	const getJson = () => {

		const fn_after = conf["type"] === "b" ? "" : "_0901";

		// 読み込むJSONファイル
		const url_monthitem = conf["json"] + "/json/itemlist" + (monthcnt + 1) + fn_after + ".json";
		if (!url_monthitem) return;

		if (dev) console.log("▼JSON読み込み:" + url_monthitem);
		// 情報を取得して表示
		// 日付をまたぐキャッシュは行わない（キャッシュはブラウザ準拠）
		fetch(url_monthitem + "?d=" + dayjs().format('YYYYMMDD'), {
			cache: 'default',	// HTTPキャッシングの制御
			mode: 'cors'	// デフォルト設定：クロスオリジンリクエストの許可
		})
			.then(res => res.json())
			.then(json => {

				// セッションキャッシュの登録
				sessionStorage.setItem('rfs-monthitem' + monthcnt, JSON.stringify(json));
				// itemsを上書き
				setItems(json);

				if (dev) console.log(`\tJSONの読み込み成功`);

			})
	}

	/* ========================================================
	SSCalenderで月の遷移イベントがあった場合に呼び出される
	=========================================================*/
	const callChangeMonth = (MONTHCNT) => {
		// 月を変更する
		setMonthCnt(MONTHCNT);
	}

	/* ========================================================
	月の遷移イベントと初回のフック
	=========================================================*/
	useEffect(() => {
		if (dev) console.log("▼月の遷移イベントと初回のフック");

		// // セッションキャッシュの削除
		// sessionStorage.removeItem('rfs-monthitem' + monthcnt);

		// セッションキャッシュの取得
		// 0：前月の全商品　1：今月の全商品　2：来月の全商品
		const cache = sessionStorage.getItem('rfs-monthitem' + monthcnt);

		// セッションキャッシュがあれば使う
		if (cache) {
			if (dev) console.log("\tキャッシュデータを使う");
			try {
				setItems(JSON.parse(cache));
			} catch (error) {
				console.log("キャッシュデータ：" + cache);
			}

			// セッションキャッシュがなければJSONの読み込み
		} else {
			if (dev) console.log(`\tJSONの読み込み monthcnt:${monthcnt}`);
			// JSONファイルの読み込み
			getJson();

		}

	}, [monthcnt])

	// JSX
	return (
		<section className="CalenderApp">
			<SSCalendar items={items} current={current} callChangeMonthState={(cnt) => { callChangeMonth(cnt) }} dev={dev} conf={conf} />
			<ItemList items={items} dev={dev} />
		</section>
	)
}
export default App;
